/* eslint-disable */

import * as companyBillService from "../../../services/companyBill";
import * as customerBillService from "../../../services/customerBill";
import * as destinationPackageService from "../../../services/destinationPackage";
import * as originPackageService from "../../../services/originPackage";
import * as settings from "../../../services/settings";

import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Select,
  Spin,
  Typography,
  Upload,
  notification,
} from "antd";
import React, { useEffect, useState } from "react";

import { isEmpty } from "validator";
import { useAccessToken } from "../../../contexts/AccessTokenContext";
import { validateDestinationPackageService } from "../../validations/validateCreateBill";

const { TextArea } = Input;
const { Title } = Typography;
const { Dragger } = Upload;

const initPage = { limit: 10, page: 1, total: 1 };

export const ModalDestinationService = ({
  isCompanyBill,
  isModalOpen,
  setIsModalOpen,
  handleOk,
  handleCancel,
  fetchCompanyBillItem,
  fetchCustomerBillItem,
  item,
  setItem,
  companyBillItem,
  isEdit,
}) => {
  const { accessToken } = useAccessToken();
  const [formOriginPackageServices] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [pageOt, setPage] = useState(1);
  const [searchData, setSearchData] = useState("");
  const [destinationPackage, setDestinationPackage] = useState([]);
  const [validateCreateBillRequired, setValidateBillRequired] = useState({
    fieldDestinationPackageId: false,
    fieldPackageService: false,
    // fieldServiceCost: false,
  });
  const [api, contextHolder] = notification.useNotification();
  const [packageService, setPackageService] = useState(1);

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };
  // Filter search from select
  const handleSearch = async (value) => {
    let searchNewPage = pageOt;
    // Check if value is undefined and value not equal to searchData set searchData is 1 default
    if (!value) {
      searchNewPage = 1;
      setPage(1);
      setSearchData("");
    } else if (value !== searchData) {
      setPage(1);
      searchNewPage = 1;
      setSearchData("");
    }
    setSearchData(value);
    await getListDestinationPackage(searchNewPage, value);
  };

  // Filter `option.label` match the user type `input`
  const filterOption = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  // Scroll data to call api pagination
  const handlePopupScroll = (e) => {
    const { target } = e;
    if (target.scrollTop + target.clientHeight === target.scrollHeight) {
      getListDestinationPackage(pageOt + 1, searchData);
    }
  };

  const getListDestinationPackage = async (pageOt, searchData) => {
    const params = { page: pageOt, limit: 20, reference: searchData };
    try {
      const data = await destinationPackageService.getDestinationPackage(accessToken, params);
      let resDestinationPackage = [];
      data.queryDestinationPackage.map((value) => {
        resDestinationPackage.push({
          value: value.id,
          label: value.reference,
        });
      });

      setDestinationPackage((prevOptions) => [...prevOptions, ...resDestinationPackage]);

      setPage(pageOt);
    } catch (err) {
      console.error("[ModalDestinationService] getListDestinationPackage: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`Get Destination package fail`}</>);
    }
  };

  const onSubmit = async () => {
    const value = await formOriginPackageServices.getFieldValue();
    const { isValid } = validateDestinationPackageService(value);
    const { service_cost, package_service, note } = value;

    if (isValid) {
      try {
        const createPackageService = {
          origin_package_id: item.app_originpackagetransportation.origin_package_id,
          package_service: package_service || "",
          note: note || "-",
          service_cost: service_cost || 0,
        };
        const updateItem = {
          id: item.id,
        };
        if (packageService === 1) {
          const originPackage = await createOriginPackageService(createPackageService);
          updateItem.origin_package_service_id = originPackage.id;
        } else {
          const destinationPackage = await createDestinationPackageService(createPackageService);
          updateItem.destination_package_service_id = destinationPackage.id;
        }
        if (isCompanyBill) {
          await updateCompanyBillItem(updateItem);
        } else {
          await updateCustomerBillItem(updateItem);
        }
        openNotificationWithIcon(
          settings.NotificationType.SUCCESS,
          <>{"Success."}</>,
          <>{"update bill item success"}</>
        );
        formOriginPackageServices.resetFields();
      } catch (err) {
        console.error("[ModalDestinationService] onSubmit: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      }
    } else {
      openNotificationWithIcon(
        settings.NotificationType.ERROR,
        <>{"ERROR."}</>,
        <>{`Please check data is request create destination service`}</>
      );
    }

    setIsModalOpen(false);
    setLoading(false);
  };

  const createDestinationPackageService = async (data) => {
    try {
      const destinationPackage = await destinationPackageService.createDestinationPackageService(accessToken, data);

      return destinationPackage;
    } catch (err) {
      console.error("[ModalDestinationService] createDestinationPackageService: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      return err;
    }
  };

  const createOriginPackageService = async (data) => {
    try {
      const originPackage = await originPackageService.createOriginPackageService(accessToken, data);
      return originPackage;
    } catch (err) {
      console.error("[ModalDestinationService] createOriginPackageService: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      return err;
    }
  };

  const updateCompanyBillItem = async (data) => {
    try {
      const response = await companyBillService.updateCompanyBillItem(accessToken, data);
      const param = { id: item.company_bill_no, limit: 10, page: 1 };
      fetchCompanyBillItem(param);
      return response;
    } catch (err) {
      console.error("[ModalDestinationService] updateCompanyBillItem: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      return err;
    }
  };

  const updateCustomerBillItem = async (data) => {
    try {
      const response = await customerBillService.updateCustomerBillItem(accessToken, data);

      const param = { id: item.company_bill_no, limit: 10, page: 1 };
      fetchCustomerBillItem(param);
      return response;
    } catch (err) {
      console.error("[ModalDestinationService] updateCustomerBillItem: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      return err;
    }
  };

  const handleCancelModal = () => {
    handleCancel();
    formOriginPackageServices.resetFields();
  };

  const isValidateDestinationPackage = (_, value) => {
    if (value == "" || value == undefined) {
      setValidateBillRequired({
        ...validateCreateBillRequired,
        fieldDestinationPackageId: false,
      });
      return Promise.reject();
    }

    setValidateBillRequired({
      ...validateCreateBillRequired,
      fieldDestinationPackageId: true,
    });
  };

  const isValidatePackageService = (_, value) => {
    if (value == "" || value == undefined) {
      setValidateBillRequired({
        ...validateCreateBillRequired,
        fieldPackageService: false,
      });
      return Promise.reject();
    }

    setValidateBillRequired({
      ...validateCreateBillRequired,
      fieldPackageService: true,
    });
  };

  const isValidateServiceCost = (_, value) => {
    if (isEmpty(value)) {
      setValidateBillRequired({
        ...validateCreateBillRequired,
        fieldServiceCost: false,
      });
      return Promise.reject("Field is required");
    }

    // Check if the value is a valid number
    if (typeof value !== "number" || !Number.isFinite(value)) {
      setValidateBillRequired({
        ...validateCreateBillRequired,
        fieldServiceCost: false,
      });
      return Promise.reject("Must be a valid number");
    }

    // If the value is valid, proceed
    setValidateBillRequired({
      ...validateCreateBillRequired,
      fieldServiceCost: true,
    });
    return Promise.resolve();
  };
  const selectListOriginPackageService = [
    {
      value: "OD",
      label: "Origin Delivery - OD",
    },
    {
      value: "WC",
      label: "Wooden Crate - WC",
    },
    {
      value: "IN",
      label: "Insurance - IN",
    },
  ];

  const selectListDestinationPackageService = [
    {
      value: "DD",
      label: "Destination Delivery - DD",
    },
  ];

  const onChange = async (e) => {
    return new Promise((resolve) => {
      resolve(setPackageService(e.target.value));
    });
  };

  useEffect(() => {
    setLoading(true);
    if (!accessToken) return;
    setLoading(false);
    getListDestinationPackage(pageOt);
  }, [accessToken]);

  return (
    <>
      {contextHolder}
      <Modal
        title={"Add/Edit Service"}
        open={isModalOpen}
        className="rounded-lg border-2"
        closable={true}
        centered={true}
        forceRender={true}
        onCancel={handleCancelModal}
        footer={() => (
          <>
            <Button onClick={onSubmit} type="primary">
              {"Save"}
            </Button>
            <Button onClick={handleCancelModal}>{"Cancel"}</Button>
          </>
        )}
      >
        <Spin spinning={loading}>
          <Col span={24}>
            <Form
              form={formOriginPackageServices}
              labelAlign="left"
              labelCol={{
                flex: "160px",
              }}
            >
              <Form.Item label={"Service :"} name="service" key="service" style={{ marginBottom: "1rem" }}>
                <Radio.Group
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                  }}
                  onChange={onChange}
                  value={packageService}
                  options={[
                    {
                      disabled: item?.app_originpackageservice?.id ? true : false,
                      value: 1,
                      label: "Origin Package Service",
                    },
                    {
                      disabled: item?.app_destinationpackageservice?.id ? true : false,
                      value: 2,
                      label: "Destination Package Service",
                    },
                  ]}
                />
              </Form.Item>

              <Form.Item
                label={"Package Service:"}
                name="package_service"
                key="package_service"
                style={{ marginBottom: "1rem" }}
                rules={[
                  {
                    required: true,
                  },
                  {
                    validator: isValidatePackageService,
                  },
                ]}
              >
                <Select
                  style={{
                    width: "100%",
                  }}
                  placeholder={"Please Package Service"}
                  allowClear
                  options={packageService === 1 ? selectListOriginPackageService : selectListDestinationPackageService}
                />
              </Form.Item>
              <Form.Item label={"Service Costs :"} name="service_cost" key="service_cost">
                <InputNumber addonAfter={"baht"} style={{ width: "100%" }} min={0.01} step="0.01" />
              </Form.Item>
              <Form.Item label={"Note : "} name="note" key="note" style={{ marginBottom: "1rem" }}>
                <TextArea allowClear={true} rows={4} />
              </Form.Item>
            </Form>
          </Col>
        </Spin>
      </Modal>
    </>
  );
};
